import {Component, inject} from '@angular/core';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {AuthenticationService} from '../../authentication.service';
import {VerifyDto} from '../../dtos/verify.dto';
import {MemoryService} from '../../../../core/services/memory.service';
import {LoginResponseDto} from '../../dtos/login-response.dto';
import {ErrorService} from '../../../../core/services/error.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-verify',
  imports: [
    TextButton,
    TranslocoPipe,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatDialogClose
  ],
  templateUrl: './verify.dialog.html',
  styleUrl: './verify.dialog.scss'
})
export class VerifyDialog {
  dialogRef = inject(MatDialogRef<VerifyDialog>);
  authenticationService: AuthenticationService = inject(AuthenticationService);
  memoryService: MemoryService = inject(MemoryService);
  translocoService = inject(TranslocoService);
  errorService = inject(ErrorService);

  error?: string;

  verificationCode: FormControl = new FormControl('');

  verify() {
    const verifyDto: VerifyDto = {verificationCode: this.verificationCode.value};

    this.authenticationService.verify(verifyDto).subscribe({
      next: (loginResponseDto: LoginResponseDto) => {
        this.error = undefined;
        this.memoryService.isNewUser = loginResponseDto.isNew;
        this.memoryService.patientId = loginResponseDto.patientId;
        this.memoryService.accessToken = loginResponseDto.accessToken;
        this.dialogRef.close(true);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.error = this.translocoService.translate('error.verificationCode');
          return;
        }

        this.error = undefined;
        this.errorService.handleError(error, this.translocoService.translate('error.title.verify'));
      }
    })
  }
}
